export default __webpack_public_path__ + "static/man-plant-af54410ba581fe159f241ca97069fce4.svg";